export default __webpack_public_path__ + "static/media/alfaSmall.6e5b3c72.webp";